/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {isBs4 as ɵa,isBs5 as ɵb} from './theme-provider';